/* Carriely – fashion-laag: aankondiging, campagne-hero, tabbladen, scroll-animaties, look, rasterweergave, snel toevoegen */
(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Aankondigingsbalk: berichten wisselen elke 4,5 seconde */
  document.querySelectorAll('[data-rotator]').forEach((rotator) => {
    const msgs = Array.from(rotator.querySelectorAll('.announcement__msg'));
    if (msgs.length < 2 || reduced) return;
    let i = 0;
    let paused = false;
    rotator.addEventListener('mouseenter', () => { paused = true; });
    rotator.addEventListener('mouseleave', () => { paused = false; });
    setInterval(() => {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4500);
  });

  /* Campagne-hero: beelden wisselen met voortgangsbalk */
  document.querySelectorAll('[data-lx-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-dot]'));
    if (slides.length < 2) return;
    const speed = (parseFloat(getComputedStyle(hero).getPropertyValue('--speed')) || 6) * 1000;
    let current = 0;
    let timer;
    const show = (n) => {
      current = (n + slides.length) % slides.length;
      slides.forEach((s, i) => { s.classList.toggle('is-active', i === current); s.setAttribute('aria-hidden', String(i !== current)); });
      dots.forEach((d, i) => {
        d.classList.remove('is-active');
        if (i === current) { void d.offsetWidth; d.classList.add('is-active'); }
      });
    };
    const start = () => { clearInterval(timer); if (!reduced) timer = setInterval(() => { if (!document.hidden && !hero.classList.contains('is-paused')) show(current + 1); }, speed); };
    dots.forEach((d) => d.addEventListener('click', () => { show(Number(d.dataset.dot)); start(); }));
    hero.addEventListener('focusin', () => hero.classList.add('is-paused'));
    hero.addEventListener('focusout', () => hero.classList.remove('is-paused'));
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { show(current + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    start();
  });

  /* Tabbladen */
  document.querySelectorAll('[data-lx-tabs]').forEach((wrap) => {
    const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          select(tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length], true);
        }
      });
    });
  });

  /* Scroll-animaties: secties en productkaarten schuiven rustig in beeld */
  const revealTargets = () => document.querySelectorAll('.lx-reveal:not(.is-in), main .card:not(.lx-reveal-card)');
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        const el = en.target;
        if (el.classList.contains('card')) {
          const row = Array.from(el.parentElement ? el.parentElement.children : []);
          el.style.transitionDelay = `${Math.min(row.indexOf(el) % 4, 3) * 80}ms`;
        }
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    const observe = () => revealTargets().forEach((el) => {
      if (el.classList.contains('card')) {
        if (el.getBoundingClientRect().top < window.innerHeight) return;
        el.classList.add('lx-reveal-card');
      }
      io.observe(el);
    });
    observe();
    const coll = document.querySelector('[data-collection]');
    if (coll) new MutationObserver(observe).observe(coll, { childList: true });
  } else {
    document.querySelectorAll('.lx-reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* Campagnebanner: licht parallax-effect */
  const parallax = Array.from(document.querySelectorAll('[data-parallax]'));
  if (parallax.length && !reduced) {
    let ticking = false;
    const update = () => {
      parallax.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        el.style.transform = `translate3d(0, ${(p * -6).toFixed(2)}%, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Shop de look: punt op de foto en regel in de lijst lichten samen op */
  document.querySelectorAll('.lx-look').forEach((look) => {
    const link = (n, on) => look.querySelectorAll(`[data-spot="${n}"], [data-spot-item="${n}"]`).forEach((el) => el.classList.toggle('is-hot', on));
    look.querySelectorAll('[data-spot], [data-spot-item]').forEach((el) => {
      const n = el.dataset.spot || el.dataset.spotItem;
      el.addEventListener('mouseenter', () => link(n, true));
      el.addEventListener('mouseleave', () => link(n, false));
    });
  });

  /* Rasterweergave op collectiepagina's (grote of kleine foto's), onthouden per bezoeker */
  const setGrid = (mode) => {
    if (mode === 'large') document.documentElement.dataset.grid = 'large';
    else delete document.documentElement.dataset.grid;
    document.querySelectorAll('[data-grid-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gridSet === (mode || 'small'))));
    try { localStorage.setItem('cx-grid', mode || 'small'); } catch (e) { /* geen opslag */ }
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-grid-set]');
    if (btn) setGrid(btn.dataset.gridSet);
  });
  setGrid(document.documentElement.dataset.grid === 'large' ? 'large' : 'small');
  const results = document.querySelector('[data-collection]');
  if (results) {
    new MutationObserver(() => {
      const mode = document.documentElement.dataset.grid === 'large' ? 'large' : 'small';
      results.querySelectorAll('[data-grid-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gridSet === mode)));
    }).observe(results, { childList: true });
  }

  /* Kleurbolletje op een kaart kiest ook de variant voor "Snel toevoegen" */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    const card = sw.closest('[data-card]');
    const quick = card && card.querySelector('[data-quick-add]');
    if (!quick) return;
    const input = quick.querySelector('[name="id"]');
    if (sw.dataset.variant) { input.value = sw.dataset.variant; quick.hidden = false; } else { quick.hidden = true; }
  });
})();
